const data = [
	{
		ID: '1',
		type: 'Cu',
		name: '島村卯月',
		kana: 'しまむらうづき',
		height: '159',
		age: '17',
		weight: '45',
		birthmonth: '4',
		birthday: '24',
		bloodtype: 'O',
		handedness: 'R',
		B: '83',
		W: '59',
		H: '87',
		constellation: '牡牛座',
		birthplace: '東京',
		hobby: '友達と長電話',
		CV: '大橋彩香',
	},
	{
		ID: '2',
		type: 'Cu',
		name: '中野有香',
		kana: 'なかのゆか',
		height: '149',
		age: '18',
		weight: '40',
		birthmonth: '3',
		birthday: '23',
		bloodtype: 'B',
		handedness: 'R',
		B: '77',
		W: '57',
		H: '81',
		constellation: '牡牛座',
		birthplace: '東京',
		hobby: '空手',
		CV: '下地紫野',
	},
	{
		ID: '3',
		type: 'Cu',
		name: '水本ゆかり',
		kana: 'みずもとゆかり',
		height: '155',
		age: '15',
		weight: '42',
		birthmonth: '10',
		birthday: '18',
		bloodtype: 'A',
		handedness: 'R',
		B: '81',
		W: '56',
		H: '82',
		constellation: '天秤座',
		birthplace: '青森',
		hobby: 'フルート',
		CV: '藤田茜',
	},
	{
		ID: '4',
		type: 'Cu',
		name: '福山舞',
		kana: 'ふくやまゆい',
		height: '132',
		age: '10',
		weight: '28',
		birthmonth: '1',
		birthday: '21',
		bloodtype: 'O',
		handedness: 'L',
		B: '64',
		W: '56',
		H: '70',
		constellation: '水瓶座',
		birthplace: '兵庫',
		hobby: '一輪車',
		CV: '',
	},
	{
		ID: '5',
		type: 'Cu',
		name: '椎名法子',
		kana: 'しいなのりこ',
		height: '147',
		age: '13',
		weight: '38',
		birthmonth: '10',
		birthday: '10',
		bloodtype: 'O',
		handedness: 'R',
		B: '76',
		W: '55',
		H: '79',
		constellation: '天秤座',
		birthplace: '大阪',
		hobby: '新作ドーナツの試食',
		CV: '都丸ちよ',
	},
	{
		ID: '6',
		type: 'Cu',
		name: '今井加奈',
		kana: 'いまいかな',
		height: '153',
		age: '16',
		weight: '41',
		birthmonth: '3',
		birthday: '3',
		bloodtype: 'O',
		handedness: 'R',
		B: '81',
		W: '56',
		H: '79',
		constellation: '魚座',
		birthplace: '高知',
		hobby: '友達とおしゃべり',
		CV: '',
	},
	{
		ID: '7',
		type: 'Cu',
		name: '持田亜里沙',
		kana: 'もちだありさ',
		height: '156',
		age: '21',
		weight: '45',
		birthmonth: '8',
		birthday: '24',
		bloodtype: 'AB',
		handedness: 'R',
		B: '77',
		W: '54',
		H: '76',
		constellation: '乙女座',
		birthplace: '長野',
		hobby: '子供と遊ぶこと',
		CV: '',
	},
	{
		ID: '8',
		type: 'Cu',
		name: '三村かな子',
		kana: 'みむらかなこ',
		height: '153',
		age: '17',
		weight: '52',
		birthmonth: '1',
		birthday: '6',
		bloodtype: 'O',
		handedness: 'R',
		B: '90',
		W: '65',
		H: '89',
		constellation: '山羊座',
		birthplace: '東京',
		hobby: 'お菓子作り',
		CV: '大坪由香',
	},
	{
		ID: '9',
		type: 'Cu',
		name: '奥山沙織',
		kana: 'おくやまさおり',
		height: '156',
		age: '19',
		weight: '47',
		birthmonth: '6',
		birthday: '12',
		bloodtype: 'B',
		handedness: 'R',
		B: '83',
		W: '57',
		H: '81',
		constellation: '双子座',
		birthplace: '秋田',
		hobby: '読書',
		CV: '',
	},
	{
		ID: '10',
		type: 'Cu',
		name: '間中美里',
		kana: 'まなかみさと',
		height: '160',
		age: '20',
		weight: '46',
		birthmonth: '11',
		birthday: '6',
		bloodtype: 'AB',
		handedness: 'R',
		B: '84',
		W: '57',
		H: '85',
		constellation: '蟹座',
		birthplace: '神奈川',
		hobby: '旅行',
		CV: '',
	},
	{
		ID: '11',
		type: 'Cu',
		name: '小日向美穂',
		kana: 'こひなたみほ',
		height: '155',
		age: '17',
		weight: '42',
		birthmonth: '12',
		birthday: '16',
		bloodtype: 'O',
		handedness: 'L',
		B: '82',
		W: '59',
		H: '86',
		constellation: '射手座',
		birthplace: '熊本',
		hobby: 'ひなたぼっこ',
		CV: '津田美波',
	},
	{
		ID: '12',
		type: 'Cu',
		name: '緒方智絵里',
		kana: 'おがたちえり',
		height: '153',
		age: '16',
		weight: '42',
		birthmonth: '6',
		birthday: '11',
		bloodtype: 'A',
		handedness: 'R',
		B: '79',
		W: '57',
		H: '80',
		constellation: '双子座',
		birthplace: '三重',
		hobby: '四つ葉のクローバー集め',
		CV: '大空直美',
	},
	{
		ID: '13',
		type: 'Cu',
		name: '五十嵐響子',
		kana: 'いがらしきょうこ',
		height: '154',
		age: '15',
		weight: '43',
		birthmonth: '8',
		birthday: '10',
		bloodtype: 'AB',
		handedness: 'R',
		B: '81',
		W: '58',
		H: '80',
		constellation: '獅子座',
		birthplace: '鳥取',
		hobby: '家事全般',
		CV: '種崎敦美',
	},
	{
		ID: '14',
		type: 'Cu',
		name: '柳瀬美由紀',
		kana: 'やなせみゆき',
		height: '144',
		age: '14',
		weight: '33',
		birthmonth: '3',
		birthday: '16',
		bloodtype: 'O',
		handedness: 'R',
		B: '75',
		W: '54',
		H: '77',
		constellation: '魚座',
		birthplace: '北海道',
		hobby: 'ぬいぐるみ集め',
		CV: '',
	},
	{
		ID: '15',
		type: 'Cu',
		name: '櫻井桃華',
		kana: 'さくらいももか',
		height: '154',
		age: '12',
		weight: '39',
		birthmonth: '4',
		birthday: '8',
		bloodtype: 'A',
		handedness: 'R',
		B: '72',
		W: '53',
		H: '75',
		constellation: '牡羊座',
		birthplace: '神戸',
		hobby: 'ティータイム',
		CV: '照井春佳',
	},
	{
		ID: '16',
		type: 'Cu',
		name: '江上椿',
		kana: 'えがみつばき',
		height: '161',
		age: '19',
		weight: '46',
		birthmonth: '2',
		birthday: '6',
		bloodtype: 'A',
		handedness: 'L',
		B: '80',
		W: '57',
		H: '80',
		constellation: '水瓶座',
		birthplace: '新潟',
		hobby: '写真を撮ること',
		CV: '',
	},
	{
		ID: '17',
		type: 'Cu',
		name: '長富蓮実',
		kana: 'ながとみはすみ',
		height: '161',
		age: '16',
		weight: '45',
		birthmonth: '3',
		birthday: '19',
		bloodtype: 'A',
		handedness: 'R',
		B: '83',
		W: '56',
		H: '85',
		constellation: '魚座',
		birthplace: '島根',
		hobby: 'ボウリング・古着屋巡り',
		CV: '',
	},
	{
		ID: '18',
		type: 'Cu',
		name: '横山千佳',
		kana: 'よこやまちか',
		height: '127',
		age: '9',
		weight: '31',
		birthmonth: '12',
		birthday: '18',
		bloodtype: 'A',
		handedness: 'R',
		B: '60',
		W: '55',
		H: '65',
		constellation: '射手座',
		birthplace: '宮崎',
		hobby: '魔法少女ごっこ',
		CV: '',
	},
	{
		ID: '19',
		type: 'Cu',
		name: '関裕美',
		kana: 'せきひろみ',
		height: '155',
		age: '14',
		weight: '43',
		birthmonth: '8',
		birthday: '17',
		bloodtype: 'A',
		handedness: 'R',
		B: '78',
		W: '55',
		H: '80',
		constellation: '獅子座',
		birthplace: '富山',
		hobby: 'アクセサリー作り',
		CV: '会沢紗弥',
	},
	{
		ID: '20',
		type: 'Cu',
		name: '太田優',
		kana: 'おおたゆう',
		height: '159',
		age: '21',
		weight: '45',
		birthmonth: '1',
		birthday: '28',
		bloodtype: 'AB',
		handedness: 'B',
		B: '89',
		W: '57',
		H: '87',
		constellation: '水瓶座',
		birthplace: '千葉',
		hobby: '犬のトリミング、美容',
		CV: '',
	},
	{
		ID: '21',
		type: 'Cu',
		name: '棟方愛海',
		kana: 'むねかたあつみ',
		height: '151',
		age: '14',
		weight: '41',
		birthmonth: '8',
		birthday: '1',
		bloodtype: 'A',
		handedness: 'B',
		B: '73',
		W: '56',
		H: '75',
		constellation: '獅子座',
		birthplace: '青森',
		hobby: '指の運動',
		CV: '藤本彩花',
	},
	{
		ID: '22',
		type: 'Cu',
		name: '藤本里奈',
		kana: 'ふじもとりな',
		height: '154',
		age: '18',
		weight: '41',
		birthmonth: '10',
		birthday: '14',
		bloodtype: 'A',
		handedness: 'R',
		B: '77',
		W: '55',
		H: '80',
		constellation: '天秤座',
		birthplace: '湘南',
		hobby: '単車乗り、コンビニで立ち読み',
		CV: '金子真由美',
	},
	{
		ID: '23',
		type: 'Cu',
		name: '大原みちる',
		kana: 'おおはらみちる',
		height: '153',
		age: '15',
		weight: '40',
		birthmonth: '4',
		birthday: '12',
		bloodtype: 'O',
		handedness: 'R',
		B: '78',
		W: '55',
		H: '80',
		constellation: '牡羊座',
		birthplace: '福井',
		hobby: '食べること',
		CV: '',
	},
	{
		ID: '24',
		type: 'Cu',
		name: '遊佐こずえ',
		kana: 'ゆさこずえ',
		height: '130',
		age: '11',
		weight: '28',
		birthmonth: '2',
		birthday: '19',
		bloodtype: 'B',
		handedness: 'R',
		B: '62',
		W: '50',
		H: '55',
		constellation: '魚座',
		birthplace: '高知',
		hobby: 'しゅみってなぁに？',
		CV: '花谷麻妃',
	},
	{
		ID: '25',
		type: 'Cu',
		name: '大沼くるみ',
		kana: 'おおぬまくるみ',
		height: '145',
		age: '13',
		weight: '40',
		birthmonth: '3',
		birthday: '30',
		bloodtype: 'A',
		handedness: 'R',
		B: 'おっきい',
		W: 'ふつう',
		H: 'まあまあ',
		constellation: '牡羊座',
		birthplace: '石川',
		hobby: 'ポケットティッシュ収集、お風呂に入ること',
		CV: '',
	},
	{
		ID: '26',
		type: 'Cu',
		name: '一ノ瀬志希',
		kana: 'いちのせしき',
		height: '161',
		age: '18',
		weight: '43',
		birthmonth: '5',
		birthday: '30',
		bloodtype: 'O',
		handedness: 'R',
		B: '83',
		W: '57',
		H: '82',
		constellation: '双子座',
		birthplace: '岩手',
		hobby: '観察・アヤしい科学実験・失踪',
		CV: '藍原ことみ',
	},
	{
		ID: '27',
		type: 'Cu',
		name: '前川みく',
		kana: 'まえかわみく',
		height: '152',
		age: '15',
		weight: '45',
		birthmonth: '2',
		birthday: '22',
		bloodtype: 'B',
		handedness: 'R',
		B: '85',
		W: '55',
		H: '81',
		constellation: '魚座',
		birthplace: '大阪',
		hobby: '猫カフェめぐり',
		CV: '高森奈津美',
	},
	{
		ID: '28',
		type: 'Cu',
		name: '赤西瑛梨華',
		kana: 'あかにしえりか',
		height: '154',
		age: '16',
		weight: '55',
		birthmonth: '7',
		birthday: '7',
		bloodtype: 'O',
		handedness: 'B',
		B: '92',
		W: '59',
		H: '88',
		constellation: '蟹座',
		birthplace: '岡山',
		hobby: '漫才鑑賞',
		CV: '',
	},
	{
		ID: '29',
		type: 'Cu',
		name: '松原早耶',
		kana: 'まつばらさや',
		height: '156',
		age: '18',
		weight: '43',
		birthmonth: '12',
		birthday: '28',
		bloodtype: 'AB',
		handedness: 'R',
		B: '83',
		W: '58',
		H: '86',
		constellation: '山羊座',
		birthplace: '兵庫',
		hobby: 'ブログ',
		CV: '',
	},
	{
		ID: '30',
		type: 'Cu',
		name: '相原雪乃',
		kana: 'あいばらゆきの',
		height: '160',
		age: '22',
		weight: '51',
		birthmonth: '2',
		birthday: '14',
		bloodtype: 'A',
		handedness: 'L',
		B: '92',
		W: '58',
		H: '90',
		constellation: '水瓶座',
		birthplace: '秋田',
		hobby: '紅茶',
		CV: '',
	},
	{
		ID: '31',
		type: 'Cu',
		name: '宮本フレデリカ',
		kana: 'みやもとふれでりか',
		height: '164',
		age: '19',
		weight: '46',
		birthmonth: '2',
		birthday: '14',
		bloodtype: 'B',
		handedness: 'L',
		B: '83',
		W: '57',
		H: '85',
		constellation: '水瓶座',
		birthplace: 'パリ',
		hobby: 'ファッション',
		CV: '髙野麻美',
	},
	{
		ID: '32',
		type: 'Cu',
		name: '小早川紗枝',
		kana: 'こばやかわさえ',
		height: '148',
		age: '15',
		weight: '42',
		birthmonth: '10',
		birthday: '18',
		bloodtype: 'AB',
		handedness: 'R',
		B: '78',
		W: '56',
		H: '80',
		constellation: '天秤座',
		birthplace: '京都',
		hobby: '日本舞踊',
		CV: '立花理香',
	},
	{
		ID: '33',
		type: 'Cu',
		name: '西園寺琴歌',
		kana: 'さいおんじことか',
		height: '156',
		age: '17',
		weight: '46',
		birthmonth: '1',
		birthday: '23',
		bloodtype: 'O',
		handedness: 'R',
		B: '87',
		W: '57',
		H: '85',
		constellation: '水瓶座',
		birthplace: '東京',
		hobby: '押し花作り',
		CV: '',
	},
	{
		ID: '34',
		type: 'Cu',
		name: '双葉杏',
		kana: 'ふたばあんず',
		height: '139',
		age: '17',
		weight: '30',
		birthmonth: '9',
		birthday: '2',
		bloodtype: 'B',
		handedness: 'R',
		B: '?',
		W: '?',
		H: '?',
		constellation: '花も恥らう乙女座',
		birthplace: '北海道',
		hobby: 'なし',
		CV: '五十嵐裕美',
	},
	{
		ID: '35',
		type: 'Cu',
		name: '楊菲菲',
		kana: 'やおふぇいふぇい',
		height: '152',
		age: '15',
		weight: '41',
		birthmonth: '9',
		birthday: '29',
		bloodtype: 'O',
		handedness: 'R',
		B: '82',
		W: '58',
		H: '84',
		constellation: '天秤座',
		birthplace: '香港',
		hobby: '料理',
		CV: '',
	},
	{
		ID: '36',
		type: 'Cu',
		name: '桃井あずき',
		kana: 'ももいあずき',
		height: '145',
		age: '15',
		weight: '40',
		birthmonth: '7',
		birthday: '7',
		bloodtype: 'A',
		handedness: 'R',
		B: '80',
		W: '55',
		H: '78',
		constellation: '蟹座',
		birthplace: '長野',
		hobby: '金魚すくい',
		CV: '',
	},
	{
		ID: '37',
		type: 'Cu',
		name: '涼宮星花',
		kana: 'すずみやせいか',
		height: '158',
		age: '19',
		weight: '45',
		birthmonth: '8',
		birthday: '28',
		bloodtype: 'A',
		handedness: 'R',
		B: '82',
		W: '57',
		H: '83',
		constellation: '乙女座',
		birthplace: '岐阜',
		hobby: 'バイオリン',
		CV: '',
	},
	{
		ID: '38',
		type: 'Cu',
		name: '月宮雅',
		kana: 'つきみやみやび',
		height: '153',
		age: '18',
		weight: '44',
		birthmonth: '10',
		birthday: '30',
		bloodtype: 'B',
		handedness: 'R',
		B: '86',
		W: '56',
		H: '82',
		constellation: '蠍座',
		birthplace: '東京',
		hobby: 'ママとショッピング',
		CV: '',
	},
	{
		ID: '39',
		type: 'Cu',
		name: '兵藤レナ',
		kana: 'ひょうどうれな',
		height: '167',
		age: '27',
		weight: '48',
		birthmonth: '10',
		birthday: '3',
		bloodtype: 'O',
		handedness: 'L',
		B: '92',
		W: '56',
		H: '84',
		constellation: '天秤座',
		birthplace: '東京',
		hobby: 'トランプ',
		CV: '',
	},
	{
		ID: '40',
		type: 'Cu',
		name: '丹羽仁美',
		kana: 'にわひとみ',
		height: '157',
		age: '18',
		weight: '43',
		birthmonth: '6',
		birthday: '4',
		bloodtype: 'B',
		handedness: 'R',
		B: '81',
		W: '55',
		H: '79',
		constellation: '双子座',
		birthplace: '名古屋',
		hobby: '史跡巡り・武将グッズ収集',
		CV: '',
	},
	{
		ID: '41',
		type: 'Cu',
		name: '道明寺歌鈴',
		kana: 'どうみょうじかりん',
		height: '155',
		age: '17',
		weight: '43',
		birthmonth: '1',
		birthday: '1',
		bloodtype: 'A',
		handedness: 'R',
		B: '80',
		W: '55',
		H: '83',
		constellation: '山羊座',
		birthplace: '奈良',
		hobby: '境内のお掃除',
		CV: '新田ひより',
	},
	{
		ID: '42',
		type: 'Cu',
		name: '柳清良',
		kana: 'やなぎきよら',
		height: '158',
		age: '23',
		weight: '47',
		birthmonth: '5',
		birthday: '12',
		bloodtype: 'O',
		handedness: 'R',
		B: '85',
		W: '58',
		H: '86',
		constellation: '牡牛座',
		birthplace: '愛媛',
		hobby: 'ドキュメンタリー番組鑑賞',
		CV: '',
	},
	{
		ID: '43',
		type: 'Cu',
		name: '井村雪菜',
		kana: 'いむらせつな',
		height: '163',
		age: '17',
		weight: '48',
		birthmonth: '8',
		birthday: '27',
		bloodtype: 'AB',
		handedness: 'R',
		B: '85',
		W: '80',
		H: '88',
		constellation: '乙女座',
		birthplace: '秋田',
		hobby: 'メイク小物集め',
		CV: '',
	},
	{
		ID: '44',
		type: 'Cu',
		name: '日下部若葉',
		kana: 'くさかべわかば',
		height: '148',
		age: '20',
		weight: '40',
		birthmonth: '5',
		birthday: '4',
		bloodtype: 'O',
		handedness: 'R',
		B: '77',
		W: '54',
		H: '78',
		constellation: '牡羊座',
		birthplace: '群馬',
		hobby: 'ジグソーパズル',
		CV: '',
	},
	{
		ID: '45',
		type: 'Cu',
		name: '榊原里美',
		kana: 'さかきばらさとみ',
		height: '162',
		age: '17',
		weight: '46',
		birthmonth: '8',
		birthday: '27',
		bloodtype: 'O',
		handedness: 'R',
		B: '91',
		W: '56',
		H: '86',
		constellation: '乙女座',
		birthplace: '山形',
		hobby: '甘いお菓子を食べること',
		CV: '',
	},
	{
		ID: '46',
		type: 'Cu',
		name: '輿水幸子',
		kana: 'こしみずさちこ',
		height: '142',
		age: '14',
		weight: '37',
		birthmonth: '11',
		birthday: '25',
		bloodtype: 'B',
		handedness: 'L',
		B: '74',
		W: '52',
		H: '75',
		constellation: '射手座',
		birthplace: '山梨',
		hobby: '勉強ノートの清書',
		CV: '竹達彩奈',
	},
	{
		ID: '47',
		type: 'Cu',
		name: '安斎都',
		kana: 'あんざいみやこ',
		height: '156',
		age: '16',
		weight: '41',
		birthmonth: '1',
		birthday: '6',
		bloodtype: 'B',
		handedness: 'R',
		B: '78',
		W: '55',
		H: '77',
		constellation: '山羊座',
		birthplace: '福井',
		hobby: '探偵ドラマ・推理小説を見ること',
		CV: '',
	},
	{
		ID: '48',
		type: 'Cu',
		name: '浅野風香',
		kana: 'あさのふうか',
		height: '160',
		age: '16',
		weight: '48',
		birthmonth: '2',
		birthday: '11',
		bloodtype: 'A',
		handedness: 'R',
		B: '88',
		W: '59',
		H: '84',
		constellation: '水瓶座',
		birthplace: '滋賀',
		hobby: '小説を書くこと',
		CV: '',
	},
	{
		ID: '49',
		type: 'Cu',
		name: '大西由里子',
		kana: 'おおにしゆりこ',
		height: '156',
		age: '20',
		weight: '44',
		birthmonth: '3',
		birthday: '20',
		bloodtype: 'O',
		handedness: 'R',
		B: '81',
		W: '58',
		H: '83',
		constellation: '魚座',
		birthplace: '香川',
		hobby: 'ネットサーフィン・読書',
		CV: '',
	},
	{
		ID: '50',
		type: 'Cu',
		name: '安部菜々',
		kana: 'あべなな',
		height: '146',
		age: '永遠の17歳',
		weight: '40',
		birthmonth: '5',
		birthday: '15',
		bloodtype: 'O',
		handedness: 'R',
		B: '84',
		W: '57',
		H: '84',
		constellation: '牡牛座',
		birthplace: 'ウサミン星',
		hobby: 'ウサミン星との交信',
		CV: '三宅麻理恵',
	},
	{
		ID: '51',
		type: 'Cu',
		name: '工藤忍',
		kana: 'くどうしのぶ',
		height: '154',
		age: '16',
		weight: '41',
		birthmonth: '3',
		birthday: '9',
		bloodtype: 'A',
		handedness: 'L',
		B: '78',
		W: '54',
		H: '81',
		constellation: '魚座',
		birthplace: '青森',
		hobby: 'おまけ集め',
		CV: '',
	},
	{
		ID: '52',
		type: 'Cu',
		name: '栗原ネネ',
		kana: 'くりはらねね',
		height: '161',
		age: '15',
		weight: '44',
		birthmonth: '9',
		birthday: '9',
		bloodtype: 'A',
		handedness: 'R',
		B: '77',
		W: '54',
		H: '78',
		constellation: '乙女座',
		birthplace: '群馬',
		hobby: 'テレビ鑑賞・健康づくり',
		CV: '',
	},
	{
		ID: '53',
		type: 'Cu',
		name: '古賀小春',
		kana: 'こがこはる',
		height: '140',
		age: '12',
		weight: '35',
		birthmonth: '4',
		birthday: '1',
		bloodtype: 'O',
		handedness: 'L',
		B: '72',
		W: '54',
		H: '77',
		constellation: '牡羊座',
		birthplace: '佐賀',
		hobby: 'イグアナのヒョウくんと遊ぶこと、家のお手伝い',
		CV: '',
	},
	{
		ID: '54',
		type: 'Cu',
		name: 'クラリス',
		kana: 'くらりす',
		height: '166',
		age: '20',
		weight: '45',
		birthmonth: '8',
		birthday: '26',
		bloodtype: 'AB',
		handedness: 'R',
		B: '80',
		W: '55',
		H: '82',
		constellation: '乙女座',
		birthplace: '兵庫',
		hobby: 'ボランティア',
		CV: '',
	},
	{
		ID: '55',
		type: 'Cu',
		name: '佐久間まゆ',
		kana: 'さくままゆ',
		height: '153',
		age: '16',
		weight: '40',
		birthmonth: '9',
		birthday: '7',
		bloodtype: 'B',
		handedness: 'B',
		B: '78',
		W: '54',
		H: '80',
		constellation: '乙女座',
		birthplace: '仙台',
		hobby: 'お料理、編み物',
		CV: '牧野由依',
	},
	{
		ID: '56',
		type: 'Cu',
		name: '村松さくら',
		kana: 'むらまつさくら',
		height: '145',
		age: '15',
		weight: '38',
		birthmonth: '3',
		birthday: '27',
		bloodtype: 'O',
		handedness: 'R',
		B: '75',
		W: '55',
		H: '77',
		constellation: '牡羊座',
		birthplace: '静岡',
		hobby: 'ピンクのもの集め',
		CV: '',
	},
	{
		ID: '57',
		type: 'Cu',
		name: '白菊ほたる',
		kana: 'しらぎくほたる',
		height: '156',
		age: '13',
		weight: '42',
		birthmonth: '4',
		birthday: '19',
		bloodtype: 'AB',
		handedness: 'L',
		B: '77',
		W: '53',
		H: '79',
		constellation: '牡羊座',
		birthplace: '鳥取',
		hobby: '笑顔の練習・アイドルレッスン',
		CV: '天野聡美',
	},
	{
		ID: '58',
		type: 'Cu',
		name: '早坂美玲',
		kana: 'はやさかみれい',
		height: '147',
		age: '14',
		weight: '39',
		birthmonth: '5',
		birthday: '9',
		bloodtype: 'B',
		handedness: 'R',
		B: '75',
		W: '54',
		H: '77',
		constellation: '牡牛座',
		birthplace: '宮城',
		hobby: 'ぬいぐるみ集め',
		CV: '朝井彩加',
	},
	{
		ID: '59',
		type: 'Cu',
		name: '有浦柑奈',
		kana: 'ありうらかんな',
		height: '155',
		age: '19',
		weight: '44',
		birthmonth: '3',
		birthday: '6',
		bloodtype: 'O',
		handedness: 'R',
		B: '78',
		W: '57',
		H: '80',
		constellation: '魚座',
		birthplace: '長崎',
		hobby: 'ラブ＆ピース',
		CV: '',
	},
	{
		ID: '60',
		type: 'Cu',
		name: '乙倉悠貴',
		kana: 'おとくらゆうき',
		height: '164',
		age: '13',
		weight: '40',
		birthmonth: '10',
		birthday: '6',
		bloodtype: 'A',
		handedness: 'R',
		B: '70',
		W: '53',
		H: '74',
		constellation: '天秤座',
		birthplace: '岡山',
		hobby: 'ミックスジュース作り・スクラップブック作り',
		CV: '中島由貴',
	},
	{
		ID: '61',
		type: 'Cu',
		name: '原田美世',
		kana: 'はらだみよ',
		height: '163',
		age: '20',
		weight: '46',
		birthmonth: '11',
		birthday: '14',
		bloodtype: 'O',
		handedness: 'R',
		B: '86',
		W: '59',
		H: '85',
		constellation: '蠍座',
		birthplace: '石川',
		hobby: 'クルマ・バイクいじり',
		CV: '',
	},
	{
		ID: '62',
		type: 'Cu',
		name: '池袋晶葉',
		kana: 'いけぶくろあきは',
		height: '148',
		age: '14',
		weight: '39',
		birthmonth: '6',
		birthday: '10',
		bloodtype: 'B',
		handedness: 'R',
		B: '75',
		W: '53',
		H: '74',
		constellation: '双子座',
		birthplace: '東京',
		hobby: 'ロボット制作',
		CV: '',
	},
	{
		ID: '63',
		type: 'Co',
		name: '渋谷凛',
		kana: 'しぶやりん',
		height: '165',
		age: '15',
		weight: '44',
		birthmonth: '8',
		birthday: '10',
		bloodtype: 'B',
		handedness: 'R',
		B: '80',
		W: '56',
		H: '81',
		constellation: '獅子座',
		birthplace: '東京',
		hobby: '犬の散歩',
		CV: '福原綾香',
	},
	{
		ID: '64',
		type: 'Co',
		name: '黒川千秋',
		kana: 'くろかわちあき',
		height: '163',
		age: '20',
		weight: '45',
		birthmonth: '2',
		birthday: '26',
		bloodtype: 'B',
		handedness: 'R',
		B: '86',
		W: '57',
		H: '86',
		constellation: '魚座',
		birthplace: '北海道',
		hobby: 'クラシック鑑賞',
		CV: '',
	},
	{
		ID: '65',
		type: 'Co',
		name: '松本紗理奈',
		kana: 'まつもとさりな',
		height: '165',
		age: '22',
		weight: '48',
		birthmonth: '9',
		birthday: '1',
		bloodtype: 'A',
		handedness: 'R',
		B: '92',
		W: '58',
		H: '85',
		constellation: '乙女座',
		birthplace: '東京',
		hobby: 'ショッピング',
		CV: '',
	},
	{
		ID: '66',
		type: 'Co',
		name: '桐野アヤ',
		kana: 'きりのあや',
		height: '160',
		age: '19',
		weight: '43',
		birthmonth: '4',
		birthday: '8',
		bloodtype: 'A',
		handedness: 'R',
		B: '86',
		W: '56',
		H: '86',
		constellation: '牡羊座',
		birthplace: '福岡',
		hobby: '格闘技観戦',
		CV: '',
	},
	{
		ID: '67',
		type: 'Co',
		name: '高橋礼子',
		kana: 'たかはしれいこ',
		height: '167',
		age: '31',
		weight: '51',
		birthmonth: '5',
		birthday: '8',
		bloodtype: 'O',
		handedness: 'R',
		B: '91',
		W: '62',
		H: '90',
		constellation: '牡牛座',
		birthplace: '神奈川',
		hobby: 'パーティーに行くこと',
		CV: '',
	},
	{
		ID: '68',
		type: 'Co',
		name: '相川千夏',
		kana: 'あいかわちなつ',
		height: '161',
		age: '23',
		weight: '43',
		birthmonth: '11',
		birthday: '11',
		bloodtype: 'B',
		handedness: 'R',
		B: '82',
		W: '56',
		H: '85',
		constellation: '蟹座',
		birthplace: '北海道',
		hobby: 'カフェで読書',
		CV: '',
	},
	{
		ID: '69',
		type: 'Co',
		name: '川島瑞樹',
		kana: 'かわしまみずき',
		height: '159',
		age: '28',
		weight: '44',
		birthmonth: '11',
		birthday: '25',
		bloodtype: 'A',
		handedness: 'R',
		B: '87',
		W: '57',
		H: '85',
		constellation: '射手座',
		birthplace: '大阪',
		hobby: '掃除、洗濯',
		CV: '東山奈央',
	},
	{
		ID: '70',
		type: 'Co',
		name: '神谷奈緒',
		kana: 'かみやなお',
		height: '154',
		age: '17',
		weight: '44',
		birthmonth: '9',
		birthday: '16',
		bloodtype: 'AB',
		handedness: 'L',
		B: '83',
		W: '58',
		H: '81',
		constellation: '乙女座',
		birthplace: '千葉',
		hobby: 'アニメ鑑賞',
		CV: '松井惠理子',
	},
	{
		ID: '71',
		type: 'Co',
		name: '上条春菜',
		kana: 'かみじょうはるな',
		height: '156',
		age: '18',
		weight: '42',
		birthmonth: '4',
		birthday: '10',
		bloodtype: 'O',
		handedness: 'R',
		B: '79',
		W: '56',
		H: '80',
		constellation: '牡羊座',
		birthplace: '静岡',
		hobby: '猫と縁側でお昼寝',
		CV: '長島光耶',
	},
	{
		ID: '72',
		type: 'Co',
		name: '荒木比奈',
		kana: 'あらきひな',
		height: '157',
		age: '20',
		weight: '43',
		birthmonth: '4',
		birthday: '9',
		bloodtype: 'A',
		handedness: 'R',
		B: '83',
		W: '57',
		H: '82',
		constellation: '牡羊座',
		birthplace: '神奈川',
		hobby: '漫画描く',
		CV: '田辺留依',
	},
	{
		ID: '73',
		type: 'Co',
		name: '東郷あい',
		kana: 'とうごうあい',
		height: '167',
		age: '23',
		weight: '45',
		birthmonth: '2',
		birthday: '7',
		bloodtype: 'AB',
		handedness: 'B',
		B: '82',
		W: '57',
		H: '83',
		constellation: '水瓶座',
		birthplace: '福島',
		hobby: 'サックス',
		CV: '',
	},
	{
		ID: '74',
		type: 'Co',
		name: '多田李衣菜',
		kana: 'ただりいな',
		height: '152',
		age: '17',
		weight: '41',
		birthmonth: '6',
		birthday: '30',
		bloodtype: 'A',
		handedness: 'R',
		B: '80',
		W: '55',
		H: '81',
		constellation: '蟹座',
		birthplace: '東京',
		hobby: '音楽鑑賞',
		CV: '青木瑠璃子',
	},
	{
		ID: '75',
		type: 'Co',
		name: '水木聖來',
		kana: 'みずきせいら',
		height: '155',
		age: '23',
		weight: '43',
		birthmonth: '4',
		birthday: '27',
		bloodtype: 'B',
		handedness: 'R',
		B: '82',
		W: '55',
		H: '80',
		constellation: '牡牛座',
		birthplace: '茨城',
		hobby: '犬の散歩',
		CV: '',
	},
	{
		ID: '76',
		type: 'Co',
		name: '佐々木千枝',
		kana: 'ささきちえ',
		height: '139',
		age: '11',
		weight: '33',
		birthmonth: '6',
		birthday: '7',
		bloodtype: 'AB',
		handedness: 'L',
		B: '73',
		W: '49',
		H: '73',
		constellation: '双子座',
		birthplace: '富山',
		hobby: '裁縫',
		CV: '今井麻夏',
	},
	{
		ID: '77',
		type: 'Co',
		name: '三船美優',
		kana: 'みふねみゆ',
		height: '165',
		age: '26',
		weight: '46',
		birthmonth: '2',
		birthday: '25',
		bloodtype: 'AB',
		handedness: 'R',
		B: '85',
		W: '60',
		H: '85',
		constellation: '魚座',
		birthplace: '岩手',
		hobby: 'アロマテラピー',
		CV: '原田彩楓',
	},
	{
		ID: '78',
		type: 'Co',
		name: '服部瞳子',
		kana: 'はっとりとうこ',
		height: '169',
		age: '25',
		weight: '48',
		birthmonth: '10',
		birthday: '11',
		bloodtype: 'O',
		handedness: 'L',
		B: '78',
		W: '57',
		H: '80',
		constellation: '天秤座',
		birthplace: '大分',
		hobby: '熱帯魚鑑賞・温泉巡り',
		CV: '',
	},
	{
		ID: '79',
		type: 'Co',
		name: '木場真奈美',
		kana: 'きばまなみ',
		height: '172',
		age: '25',
		weight: '50',
		birthmonth: '8',
		birthday: '8',
		bloodtype: 'AB',
		handedness: 'R',
		B: '88',
		W: '60',
		H: '89',
		constellation: '獅子座',
		birthplace: '長崎',
		hobby: '筋トレ・料理',
		CV: '',
	},
	{
		ID: '80',
		type: 'Co',
		name: '藤原肇',
		kana: 'ふじわらはじめ',
		height: '161',
		age: '16',
		weight: '43',
		birthmonth: '6',
		birthday: '15',
		bloodtype: 'B',
		handedness: 'B',
		B: '80',
		W: '55',
		H: '84',
		constellation: '双子座',
		birthplace: '岡山',
		hobby: '陶芸、釣り',
		CV: '鈴木みのり',
	},
	{
		ID: '81',
		type: 'Co',
		name: '新田美波',
		kana: 'にったみなみ',
		height: '165',
		age: '19',
		weight: '45',
		birthmonth: '7',
		birthday: '27',
		bloodtype: 'O',
		handedness: 'R',
		B: '82',
		W: '55',
		H: '85',
		constellation: '獅子座',
		birthplace: '広島',
		hobby: 'ラクロス、資格取得',
		CV: '洲崎綾',
	},
	{
		ID: '82',
		type: 'Co',
		name: '水野翠',
		kana: 'みずのみどり',
		height: '164',
		age: '18',
		weight: '47',
		birthmonth: '12',
		birthday: '5',
		bloodtype: 'AB',
		handedness: 'R',
		B: '80',
		W: '54',
		H: '81',
		constellation: '射手座',
		birthplace: '愛知',
		hobby: '弓道',
		CV: '',
	},
	{
		ID: '83',
		type: 'Co',
		name: '古澤頼子',
		kana: 'ふるさわよりこ',
		height: '166',
		age: '17',
		weight: '45',
		birthmonth: '5',
		birthday: '18',
		bloodtype: 'A',
		handedness: 'L',
		B: '81',
		W: '59',
		H: '83',
		constellation: '牡牛座',
		birthplace: '茨城',
		hobby: '美術展・博物展観覧',
		CV: '',
	},
	{
		ID: '84',
		type: 'Co',
		name: '橘ありす',
		kana: 'たちばなありす',
		height: '141',
		age: '12',
		weight: '34',
		birthmonth: '7',
		birthday: '31',
		bloodtype: 'A',
		handedness: 'R',
		B: '68',
		W: '52',
		H: '67',
		constellation: '獅子座',
		birthplace: '兵庫',
		hobby: 'ゲーム・読書(ミステリー)',
		CV: '佐藤亜美菜',
	},
	{
		ID: '85',
		type: 'Co',
		name: '鷺沢文香',
		kana: 'さぎさわふみか',
		height: '162',
		age: '19',
		weight: '45',
		birthmonth: '10',
		birthday: '27',
		bloodtype: 'AB',
		handedness: 'R',
		B: '84',
		W: '54',
		H: '81',
		constellation: '蠍座',
		birthplace: '長野',
		hobby: '本屋巡り・栞作り',
		CV: 'M・A・O',
	},
	{
		ID: '86',
		type: 'Co',
		name: '八神マキノ',
		kana: 'やがみまきの',
		height: '160',
		age: '18',
		weight: '45',
		birthmonth: '11',
		birthday: '7',
		bloodtype: 'B',
		handedness: 'R',
		B: '85',
		W: '56',
		H: '83',
		constellation: '蠍座',
		birthplace: '岐阜',
		hobby: '諜報活動',
		CV: '',
	},
	{
		ID: '87',
		type: 'Co',
		name: 'ライラ',
		kana: 'らいら',
		height: '150',
		age: '16',
		weight: '40',
		birthmonth: '5',
		birthday: '21',
		bloodtype: 'O',
		handedness: 'R',
		B: '75',
		W: '54',
		H: '78',
		constellation: '双子座',
		birthplace: 'ドバイ',
		hobby: '公園で知らない人とおしゃべり',
		CV: '',
	},
	{
		ID: '88',
		type: 'Co',
		name: '浅利七海',
		kana: 'あさりななみ',
		height: '151',
		age: '14',
		weight: '41',
		birthmonth: '10',
		birthday: '9',
		bloodtype: 'A',
		handedness: 'R',
		B: '75',
		W: '55',
		H: '77',
		constellation: '天秤座',
		birthplace: '青森',
		hobby: '釣り・絵日記',
		CV: '',
	},
	{
		ID: '89',
		type: 'Co',
		name: 'ヘレン',
		kana: 'へれん',
		height: '158',
		age: '24',
		weight: '46',
		birthmonth: '4',
		birthday: '4',
		bloodtype: 'AB',
		handedness: 'R',
		B: '90',
		W: '58',
		H: '81',
		constellation: '牡羊座',
		birthplace: '海の向こう',
		hobby: 'DVD鑑賞',
		CV: '',
	},
	{
		ID: '90',
		type: 'Co',
		name: '松永涼',
		kana: 'まつながりょう',
		height: '160',
		age: '18',
		weight: '47',
		birthmonth: '10',
		birthday: '1',
		bloodtype: 'AB',
		handedness: 'R',
		B: '90',
		W: '56',
		H: '86',
		constellation: '天秤座',
		birthplace: '東京',
		hobby: 'ホラー映画鑑賞',
		CV: '千菅春香',
	},
	{
		ID: '91',
		type: 'Co',
		name: '小室千奈美',
		kana: 'こむろちなみ',
		height: '164',
		age: '19',
		weight: '45',
		birthmonth: '6',
		birthday: '9',
		bloodtype: 'AB',
		handedness: 'R',
		B: '84',
		W: '56',
		H: '82',
		constellation: '双子座',
		birthplace: '愛知',
		hobby: 'ダーツ',
		CV: '',
	},
	{
		ID: '92',
		type: 'Co',
		name: '高峯のあ',
		kana: 'たかみねのあ',
		height: '168',
		age: '24',
		weight: '48',
		birthmonth: '3',
		birthday: '25',
		bloodtype: 'B',
		handedness: 'R',
		B: '87',
		W: '55',
		H: '86',
		constellation: '牡羊座',
		birthplace: '奈良',
		hobby: '天体観測',
		CV: '',
	},
	{
		ID: '93',
		type: 'Co',
		name: '高垣楓',
		kana: 'たかがきかえで',
		height: '171',
		age: '25',
		weight: '49',
		birthmonth: '6',
		birthday: '14',
		bloodtype: 'AB',
		handedness: 'L',
		B: '81',
		W: '57',
		H: '83',
		constellation: '双子座',
		birthplace: '和歌山',
		hobby: '温泉めぐり',
		CV: '早見沙織',
	},
	{
		ID: '94',
		type: 'Co',
		name: '神崎蘭子',
		kana: 'かんざきらんこ',
		height: '156',
		age: '14',
		weight: '41',
		birthmonth: '4',
		birthday: '8',
		bloodtype: 'A',
		handedness: 'R',
		B: '81',
		W: '57',
		H: '80',
		constellation: '牡羊座',
		birthplace: '熊本',
		hobby: '絵を描くこと',
		CV: '内田真礼',
	},
	{
		ID: '95',
		type: 'Co',
		name: '伊集院恵',
		kana: 'いじゅういんめぐみ',
		height: '160',
		age: '21',
		weight: '44',
		birthmonth: '9',
		birthday: '24',
		bloodtype: 'O',
		handedness: 'L',
		B: '86',
		W: '56',
		H: '81',
		constellation: '天秤座',
		birthplace: '東京',
		hobby: '一人旅',
		CV: '',
	},
	{
		ID: '96',
		type: 'Co',
		name: '柊志乃',
		kana: 'ひいらぎしの',
		height: '167',
		age: '31',
		weight: '43',
		birthmonth: '12',
		birthday: '25',
		bloodtype: 'AB',
		handedness: 'L',
		B: '84',
		W: '54',
		H: '83',
		constellation: '山羊座',
		birthplace: '山梨',
		hobby: 'ワインツーリズム(産地巡り)',
		CV: '',
	},
	{
		ID: '97',
		type: 'Co',
		name: '北条加蓮',
		kana: 'ほうじょうかれん',
		height: '155',
		age: '16',
		weight: '42',
		birthmonth: '9',
		birthday: '5',
		bloodtype: 'B',
		handedness: 'R',
		B: '83',
		W: '55',
		H: '81',
		constellation: '乙女座',
		birthplace: '東京',
		hobby: 'ネイル',
		CV: '渕上舞',
	},
	{
		ID: '98',
		type: 'Co',
		name: 'ケイト',
		kana: 'けいと',
		height: '157',
		age: '20',
		weight: '45',
		birthmonth: '8',
		birthday: '15',
		bloodtype: 'O',
		handedness: 'R',
		B: '83',
		W: '59',
		H: '85',
		constellation: '獅子座',
		birthplace: 'イギリス',
		hobby: '日本の雑誌を見るコト',
		CV: '',
	},
	{
		ID: '99',
		type: 'Co',
		name: '瀬名詩織',
		kana: 'せなしおり',
		height: '165',
		age: '19',
		weight: '48',
		birthmonth: '1',
		birthday: '10',
		bloodtype: 'A',
		handedness: 'R',
		B: '85',
		W: '58',
		H: '83',
		constellation: '山羊座',
		birthplace: '沖縄',
		hobby: '海沿いを散歩',
		CV: '',
	},
	{
		ID: '100',
		type: 'Co',
		name: '綾瀬穂乃香',
		kana: 'あやせほのか',
		height: '161',
		age: '17',
		weight: '46',
		birthmonth: '5',
		birthday: '29',
		bloodtype: 'A',
		handedness: 'R',
		B: '85',
		W: '57',
		H: '84',
		constellation: '双子座',
		birthplace: '宮城',
		hobby: 'バレエ',
		CV: '',
	},
	{
		ID: '101',
		type: 'Co',
		name: '佐城雪美',
		kana: 'さじょうゆみ',
		height: '137',
		age: '10',
		weight: '30',
		birthmonth: '9',
		birthday: '28',
		bloodtype: 'AB',
		handedness: 'R',
		B: '63',
		W: '47',
		H: '65',
		constellation: '天秤座',
		birthplace: '京都',
		hobby: 'ペット(黒猫)と会話',
		CV: '中澤ミナ',
	},
	{
		ID: '102',
		type: 'Co',
		name: '篠原礼',
		kana: 'しのはられい',
		height: '171',
		age: '27',
		weight: '49',
		birthmonth: '11',
		birthday: '22',
		bloodtype: 'B',
		handedness: 'L',
		B: '93',
		W: '58',
		H: '88',
		constellation: '蠍座',
		birthplace: '宮崎',
		hobby: '社交ダンス',
		CV: '',
	},
	{
		ID: '103',
		type: 'Co',
		name: '和久井留美',
		kana: 'わくいるみ',
		height: '168',
		age: '26',
		weight: '49',
		birthmonth: '4',
		birthday: '7',
		bloodtype: 'A',
		handedness: 'L',
		B: '81',
		W: '60',
		H: '86',
		constellation: '牡羊座',
		birthplace: '広島',
		hobby: '仕事',
		CV: '',
	},
	{
		ID: '104',
		type: 'Co',
		name: '吉岡沙紀',
		kana: 'よしおかさき',
		height: '166',
		age: '17',
		weight: '43',
		birthmonth: '5',
		birthday: '8',
		bloodtype: 'A',
		handedness: 'R',
		B: '86',
		W: '60',
		H: '85',
		constellation: '牡牛座',
		birthplace: '神奈川',
		hobby: 'ストリートアート',
		CV: '',
	},
	{
		ID: '105',
		type: 'Co',
		name: '梅木音葉',
		kana: 'うめきおとは',
		height: '172',
		age: '19',
		weight: '49',
		birthmonth: '6',
		birthday: '20',
		bloodtype: 'AB',
		handedness: 'R',
		B: '86',
		W: '58',
		H: '85',
		constellation: '双子座',
		birthplace: '北海道',
		hobby: '森林浴・ピアノ',
		CV: '',
	},
	{
		ID: '106',
		type: 'Co',
		name: '白坂小梅',
		kana: 'しらさかこうめ',
		height: '142',
		age: '13',
		weight: '34',
		birthmonth: '3',
		birthday: '28',
		bloodtype: 'AB',
		handedness: 'L',
		B: '65',
		W: '50',
		H: '70',
		constellation: '牡羊座',
		birthplace: '兵庫',
		hobby: 'ホラー・スプラッタ映画鑑賞　心霊スポット巡り',
		CV: '桜咲千依',
	},
	{
		ID: '107',
		type: 'Co',
		name: '岸部彩華',
		kana: 'きしべあやか',
		height: '162',
		age: '19',
		weight: '46',
		birthmonth: '11',
		birthday: '13',
		bloodtype: 'A',
		handedness: 'R',
		B: '89',
		W: '59',
		H: '85',
		constellation: '蠍座',
		birthplace: '埼玉',
		hobby: 'ネイルアート・エステ・岩盤浴',
		CV: '',
	},
	{
		ID: '108',
		type: 'Co',
		name: '氏家むつみ',
		kana: 'うじいえむつみ',
		height: '152',
		age: '13',
		weight: '42',
		birthmonth: '7',
		birthday: '13',
		bloodtype: 'AB',
		handedness: 'R',
		B: '78',
		W: '57',
		H: '80',
		constellation: '蟹座',
		birthplace: '栃木',
		hobby: '冒険小説を読む・冒険映画を見る事',
		CV: '',
	},
	{
		ID: '109',
		type: 'Co',
		name: '西川保奈美',
		kana: 'にしかわほなみ',
		height: '155',
		age: '16',
		weight: '55',
		birthmonth: '10',
		birthday: '23',
		bloodtype: 'A',
		handedness: 'B',
		B: '88',
		W: '60',
		H: '86',
		constellation: '天秤座',
		birthplace: '兵庫',
		hobby: 'オペラ鑑賞・宝塚鑑賞',
		CV: '',
	},
	{
		ID: '110',
		type: 'Co',
		name: '成宮由愛',
		kana: 'なるみやゆめ',
		height: '150',
		age: '13',
		weight: '40',
		birthmonth: '11',
		birthday: '3',
		bloodtype: 'AB',
		handedness: 'B',
		B: '72',
		W: '51',
		H: '73',
		constellation: '蠍座',
		birthplace: '佐賀',
		hobby: '写生・水彩画',
		CV: '',
	},
	{
		ID: '111',
		type: 'Co',
		name: '藤居朋',
		kana: 'ふじいとも',
		height: '163',
		age: '19',
		weight: '45',
		birthmonth: '7',
		birthday: '1',
		bloodtype: 'O',
		handedness: 'R',
		B: '78',
		W: '57',
		H: '83',
		constellation: '蟹座',
		birthplace: '滋賀',
		hobby: '占い',
		CV: '',
	},
	{
		ID: '112',
		type: 'Co',
		name: '塩見周子',
		kana: 'しおみしゅうこ',
		height: '163',
		age: '18',
		weight: '45',
		birthmonth: '12',
		birthday: '12',
		bloodtype: 'B',
		handedness: 'L',
		B: '82',
		W: '56',
		H: '81',
		constellation: '射手座',
		birthplace: '京都',
		hobby: '献血・ダーツ',
		CV: 'ルゥ ティン',
	},
	{
		ID: '113',
		type: 'Co',
		name: '脇山珠美',
		kana: 'わきやまたまみ',
		height: '145',
		age: '16',
		weight: '38',
		birthmonth: '9',
		birthday: '20',
		bloodtype: 'B',
		handedness: 'R',
		B: '72',
		W: '53',
		H: '75',
		constellation: '乙女座',
		birthplace: '佐賀',
		hobby: '剣道・時代小説を読むこと',
		CV: '嘉山未沙',
	},
	{
		ID: '114',
		type: 'Co',
		name: '岡崎泰葉',
		kana: 'おかざきやすは',
		height: '153',
		age: '16',
		weight: '43',
		birthmonth: '7',
		birthday: '16',
		bloodtype: 'A',
		handedness: 'L',
		B: '79',
		W: '55',
		H: '80',
		constellation: '蟹座',
		birthplace: '長崎',
		hobby: 'ドールハウス作り',
		CV: '',
	},
	{
		ID: '115',
		type: 'Co',
		name: '速水奏',
		kana: 'はやみかなで',
		height: '162',
		age: '17',
		weight: '43',
		birthmonth: '7',
		birthday: '1',
		bloodtype: 'O',
		handedness: 'R',
		B: '86',
		W: '55',
		H: '84',
		constellation: '蟹座',
		birthplace: '東京',
		hobby: '映画鑑賞',
		CV: '飯田友子',
	},
	{
		ID: '116',
		type: 'Co',
		name: '大石泉',
		kana: 'おおにしいずみ',
		height: '157',
		age: '15',
		weight: '41',
		birthmonth: '11',
		birthday: '11',
		bloodtype: 'A',
		handedness: 'R',
		B: '83',
		W: '55',
		H: '82',
		constellation: '蠍座',
		birthplace: '静岡',
		hobby: 'プログラミング',
		CV: '',
	},
	{
		ID: '117',
		type: 'Co',
		name: '松尾千鶴',
		kana: 'まつおちづる',
		height: '161',
		age: '15',
		weight: '45',
		birthmonth: '3',
		birthday: '21',
		bloodtype: 'A',
		handedness: 'R',
		B: '78',
		W: '54',
		H: '81',
		constellation: '牡羊座',
		birthplace: '静岡',
		hobby: '勉強・習字',
		CV: '',
	},
	{
		ID: '118',
		type: 'Co',
		name: '森久保乃々',
		kana: 'もりくぼのの',
		height: '149',
		age: '14',
		weight: '38',
		birthmonth: '8',
		birthday: '27',
		bloodtype: 'AB',
		handedness: 'L',
		B: '73',
		W: '55',
		H: '76',
		constellation: '乙女座',
		birthplace: '神奈川',
		hobby: 'ポエム作り・少女漫画集め',
		CV: '高橋花林',
	},
	{
		ID: '119',
		type: 'Co',
		name: 'アナスタシア',
		kana: 'あなすたしあ',
		height: '165',
		age: '15',
		weight: '43',
		birthmonth: '9',
		birthday: '19',
		bloodtype: 'O',
		handedness: 'B',
		B: '80',
		W: '54',
		H: '80',
		constellation: '乙女座',
		birthplace: '北海道',
		hobby: 'ホームパーティ・天体観測',
		CV: '上坂すみれ',
	},
	{
		ID: '120',
		type: 'Co',
		name: '大和亜季',
		kana: 'やまとあき',
		height: '165',
		age: '21',
		weight: '51',
		birthmonth: '12',
		birthday: '16',
		bloodtype: 'O',
		handedness: 'L',
		B: '92',
		W: '60',
		H: '85',
		constellation: '射手座',
		birthplace: '福岡',
		hobby: 'サバゲー、プラモ収集',
		CV: '村中知',
	},
	{
		ID: '121',
		type: 'Co',
		name: '結城晴',
		kana: 'ゆうきはる',
		height: '140',
		age: '12',
		weight: '37',
		birthmonth: '7',
		birthday: '17',
		bloodtype: 'A',
		handedness: 'R',
		B: '74',
		W: '55',
		H: '78',
		constellation: '蟹座',
		birthplace: '愛媛',
		hobby: 'サッカー',
		CV: '小市眞琴',
	},
	{
		ID: '122',
		type: 'Co',
		name: '二宮飛鳥',
		kana: 'にのみやあすか',
		height: '154',
		age: '14',
		weight: '42',
		birthmonth: '2',
		birthday: '3',
		bloodtype: 'B',
		handedness: 'R',
		B: '75',
		W: '55',
		H: '78',
		constellation: '水瓶座',
		birthplace: '静岡',
		hobby: 'ヘアアレンジ、ラジオを聴くこと、漫画を描くこと',
		CV: '青木志貴',
	},
	{
		ID: '123',
		type: 'Co',
		name: '桐生つかさ',
		kana: 'きりゅうつかさ',
		height: '164',
		age: '18',
		weight: '45',
		birthmonth: '2',
		birthday: '24',
		bloodtype: 'A',
		handedness: 'R',
		B: '83',
		W: '55',
		H: '82',
		constellation: '魚座',
		birthplace: '福井',
		hobby: '異業種交流、ホットヨガ、ぬか床の世話',
		CV: '',
	},
	{
		ID: '124',
		type: 'Co',
		name: '望月聖',
		kana: 'もちづきひじり',
		height: '150',
		age: '13',
		weight: '37',
		birthmonth: '12',
		birthday: '25',
		bloodtype: 'O',
		handedness: 'R',
		B: '82',
		W: '59',
		H: '86',
		constellation: '山羊座',
		birthplace: '長野',
		hobby: '歌を口ずさむこと',
		CV: '',
	},
	{
		ID: '125',
		type: 'Co',
		name: '鷹富士茄子',
		kana: 'たかふじかこ',
		height: '160',
		age: '20',
		weight: '43',
		birthmonth: '1',
		birthday: '1',
		bloodtype: 'AB',
		handedness: 'R',
		B: '88',
		W: '57',
		H: '88',
		constellation: '山羊座',
		birthplace: '島根',
		hobby: '隠し芸',
		CV: '',
	},
	{
		ID: '126',
		type: 'Pa',
		name: '本田未央',
		kana: 'ほんだみお',
		height: '161',
		age: '15',
		weight: '46',
		birthmonth: '12',
		birthday: '1',
		bloodtype: 'B',
		handedness: 'R',
		B: '84',
		W: '58',
		H: '87',
		constellation: '射手座',
		birthplace: '千葉',
		hobby: 'ショッピング',
		CV: '原紗友里',
	},
	{
		ID: '127',
		type: 'Pa',
		name: '高森藍子',
		kana: 'たかもりあいこ',
		height: '155',
		age: '16',
		weight: '42',
		birthmonth: '7',
		birthday: '25',
		bloodtype: 'O',
		handedness: 'R',
		B: '74',
		W: '60',
		H: '79',
		constellation: '獅子座',
		birthplace: '東京',
		hobby: '近所の公園をお散歩',
		CV: '金子有希',
	},
	{
		ID: '128',
		type: 'Pa',
		name: '並木芽衣子',
		kana: 'なみきめいこ',
		height: '160',
		age: '22',
		weight: '44',
		birthmonth: '10',
		birthday: '14',
		bloodtype: 'AB',
		handedness: 'R',
		B: '80',
		W: '57',
		H: '82',
		constellation: '天秤座',
		birthplace: '和歌山',
		hobby: '旅行',
		CV: '',
	},
	{
		ID: '129',
		type: 'Pa',
		name: '龍崎薫',
		kana: 'りゅうざきかおる',
		height: '132',
		age: '9',
		weight: '32',
		birthmonth: '7',
		birthday: '20',
		bloodtype: 'O',
		handedness: 'R',
		B: '65',
		W: '51',
		H: '70',
		constellation: '蟹座',
		birthplace: '愛媛',
		hobby: '料理',
		CV: '春瀬なつみ',
	},
	{
		ID: '130',
		type: 'Pa',
		name: '木村夏樹',
		kana: 'きむらなつき',
		height: '159',
		age: '18',
		weight: '41',
		birthmonth: '8',
		birthday: '19',
		bloodtype: 'AB',
		handedness: 'L',
		B: '82',
		W: '57',
		H: '83',
		constellation: '獅子座',
		birthplace: '茨城',
		hobby: 'ツーリング',
		CV: '安野希世乃',
	},
	{
		ID: '131',
		type: 'Pa',
		name: '松山久美子',
		kana: 'まつやまくみこ',
		height: '161',
		age: '21',
		weight: '44',
		birthmonth: '1',
		birthday: '21',
		bloodtype: 'A',
		handedness: 'R',
		B: '81',
		W: '56',
		H: '81',
		constellation: '水瓶座',
		birthplace: '神奈川',
		hobby: 'ピアノ',
		CV: '',
	},
	{
		ID: '132',
		type: 'Pa',
		name: '斉藤洋子',
		kana: 'さいとうようこ',
		height: '157',
		age: '20',
		weight: '46',
		birthmonth: '12',
		birthday: '29',
		bloodtype: 'O',
		handedness: 'R',
		B: '85',
		W: '57',
		H: '82',
		constellation: '山羊座',
		birthplace: '福岡',
		hobby: '半身浴',
		CV: '',
	},
	{
		ID: '133',
		type: 'Pa',
		name: '沢田麻理菜',
		kana: 'さわだまりな',
		height: '166',
		age: '26',
		weight: '47',
		birthmonth: '5',
		birthday: '6',
		bloodtype: 'B',
		handedness: 'R',
		B: '87',
		W: '57',
		H: '87',
		constellation: '牡牛座',
		birthplace: '長野',
		hobby: 'サーフィン',
		CV: '',
	},
	{
		ID: '134',
		type: 'Pa',
		name: '矢口美羽',
		kana: 'やぐちみう',
		height: '150',
		age: '14',
		weight: '41',
		birthmonth: '7',
		birthday: '10',
		bloodtype: 'B',
		handedness: 'R',
		B: '81',
		W: '56',
		H: '80',
		constellation: '蟹座',
		birthplace: '千葉',
		hobby: 'メール',
		CV: '',
	},
	{
		ID: '135',
		type: 'Pa',
		name: '赤城みりあ',
		kana: 'あかぎみりあ',
		height: '140',
		age: '11',
		weight: '36',
		birthmonth: '4',
		birthday: '14',
		bloodtype: 'AB',
		handedness: 'L',
		B: '75',
		W: '55',
		H: '78',
		constellation: '牡羊座',
		birthplace: '東京',
		hobby: 'おしゃべり',
		CV: '黒沢ともよ',
	},
	{
		ID: '136',
		type: 'Pa',
		name: '愛野渚',
		kana: 'あいのなぎさ',
		height: '163',
		age: '18',
		weight: '47',
		birthmonth: '8',
		birthday: '1',
		bloodtype: 'A',
		handedness: 'R',
		B: '84',
		W: '58',
		H: '85',
		constellation: '獅子座',
		birthplace: '愛知',
		hobby: 'バスケットボール',
		CV: '',
	},
	{
		ID: '137',
		type: 'Pa',
		name: '真鍋いつき',
		kana: 'まなべいつき',
		height: '165',
		age: '22',
		weight: '46',
		birthmonth: '12',
		birthday: '29',
		bloodtype: 'O',
		handedness: 'R',
		B: '85',
		W: '57',
		H: '83',
		constellation: '山羊座',
		birthplace: '石川',
		hobby: 'とにかく運動',
		CV: '',
	},
	{
		ID: '138',
		type: 'Pa',
		name: '大槻唯',
		kana: 'おおつきゆい',
		height: '155',
		age: '17',
		weight: '42',
		birthmonth: '5',
		birthday: '7',
		bloodtype: 'B',
		handedness: 'L',
		B: '84',
		W: '56',
		H: '83',
		constellation: '牡牛座',
		birthplace: '埼玉',
		hobby: 'カラオケ',
		CV: '山下七海',
	},
	{
		ID: '139',
		type: 'Pa',
		name: '姫川友紀',
		kana: 'ひめかわゆき',
		height: '161',
		age: '20',
		weight: '44',
		birthmonth: '9',
		birthday: '14',
		bloodtype: 'A',
		handedness: 'R',
		B: '80',
		W: '57',
		H: '80',
		constellation: '乙女座',
		birthplace: '宮崎',
		hobby: '野球観戦',
		CV: '杜野まこ',
	},
	{
		ID: '140',
		type: 'Pa',
		name: '喜多見柚',
		kana: 'きたみゆず',
		height: '156',
		age: '15',
		weight: '43',
		birthmonth: '12',
		birthday: '2',
		bloodtype: 'B',
		handedness: 'L',
		B: '82',
		W: '57',
		H: '82',
		constellation: '射手座',
		birthplace: '埼玉',
		hobby: 'バドミントン',
		CV: '武田羅梨沙多胡',
	},
	{
		ID: '141',
		type: 'Pa',
		name: '上田鈴帆',
		kana: 'うえだすずほ',
		height: '156',
		age: '14',
		weight: '42',
		birthmonth: '10',
		birthday: '26',
		bloodtype: 'O',
		handedness: 'R',
		B: '76',
		W: '55',
		H: '79',
		constellation: '蠍座',
		birthplace: '福岡',
		hobby: '裁縫',
		CV: '春野ななみ',
	},
	{
		ID: '142',
		type: 'Pa',
		name: '海老原菜帆',
		kana: 'えびはらなほ',
		height: '162',
		age: '17',
		weight: '58',
		birthmonth: '8',
		birthday: '3',
		bloodtype: 'O',
		handedness: 'R',
		B: '92',
		W: '65',
		H: '93',
		constellation: '獅子座',
		birthplace: '熊本',
		hobby: '散歩・和菓子屋さん巡り',
		CV: '',
	},
	{
		ID: '143',
		type: 'Pa',
		name: '及川雫',
		kana: 'おいかわしずく',
		height: '170',
		age: '16',
		weight: '56',
		birthmonth: '6',
		birthday: '3',
		bloodtype: 'O',
		handedness: 'B',
		B: '105',
		W: '64',
		H: '92',
		constellation: '双子座',
		birthplace: '岩手',
		hobby: '乳搾り・トラクターの運転',
		CV: 'のぐちゆり',
	},
	{
		ID: '144',
		type: 'Pa',
		name: '小関麗奈',
		kana: 'こぜきれいな',
		height: '148',
		age: '13',
		weight: '41',
		birthmonth: '3',
		birthday: '5',
		bloodtype: 'B',
		handedness: 'R',
		B: '75',
		W: '50',
		H: '77',
		constellation: '魚座',
		birthplace: '山形',
		hobby: 'いたずら',
		CV: '',
	},
	{
		ID: '145',
		type: 'Pa',
		name: '衛藤美紗希',
		kana: 'えとうみさき',
		height: '160',
		age: '22',
		weight: '45',
		birthmonth: '3',
		birthday: '18',
		bloodtype: 'O',
		handedness: 'L',
		B: '84',
		W: '56',
		H: '80',
		constellation: '魚座',
		birthplace: '大分',
		hobby: '携帯小説、女子力アップ',
		CV: '',
	},
	{
		ID: '146',
		type: 'Pa',
		name: '星輝子',
		kana: 'ほししょうこ',
		height: '142',
		age: '15',
		weight: '35',
		birthmonth: '6',
		birthday: '6',
		bloodtype: 'B',
		handedness: 'L',
		B: '73',
		W: '53',
		H: '75',
		constellation: '双子座',
		birthplace: '福島',
		hobby: 'キノコ栽培',
		CV: '松田颯水',
	},
	{
		ID: '147',
		type: 'Pa',
		name: '片桐早苗',
		kana: 'かたぎりさなえ',
		height: '152',
		age: '28',
		weight: '47',
		birthmonth: '3',
		birthday: '7',
		bloodtype: 'O',
		handedness: 'R',
		B: '92',
		W: '58',
		H: '84',
		constellation: '魚座',
		birthplace: '新潟',
		hobby: 'マッサージ・スーパー銭湯',
		CV: '和氣あず未',
	},
	{
		ID: '148',
		type: 'Pa',
		name: '堀裕子',
		kana: 'ほりゆうこ',
		height: '157',
		age: '16',
		weight: '44',
		birthmonth: '3',
		birthday: '13',
		bloodtype: 'O',
		handedness: 'R',
		B: '81',
		W: '58',
		H: '80',
		constellation: '魚座',
		birthplace: '福井',
		hobby: 'サイキックトレーニング',
		CV: '鈴木絵理',
	},
	{
		ID: '149',
		type: 'Pa',
		name: '西島櫂',
		kana: 'にしじまかい',
		height: '172',
		age: '19',
		weight: '49',
		birthmonth: '8',
		birthday: '17',
		bloodtype: 'O',
		handedness: 'R',
		B: '86',
		W: '59',
		H: '83',
		constellation: '獅子座',
		birthplace: '大阪',
		hobby: '水族館巡り',
		CV: '',
	},
	{
		ID: '150',
		type: 'Pa',
		name: '的場梨沙',
		kana: 'まとばりさ',
		height: '143',
		age: '12',
		weight: '38',
		birthmonth: '11',
		birthday: '19',
		bloodtype: 'B',
		handedness: 'R',
		B: '71',
		W: '58',
		H: '73',
		constellation: '蠍座',
		birthplace: '山口',
		hobby: 'ダンス、パパとデート',
		CV: '集貝はな',
	},
	{
		ID: '151',
		type: 'Pa',
		name: '財前時子',
		kana: 'ざいぜんときこ',
		height: '168',
		age: '21',
		weight: '46',
		birthmonth: '4',
		birthday: '18',
		bloodtype: 'B',
		handedness: 'R',
		B: '83',
		W: '55',
		H: '85',
		constellation: '牡羊座',
		birthplace: '名古屋',
		hobby: 'お仕置き、豚を料理すること',
		CV: '',
	},
	{
		ID: '152',
		type: 'Pa',
		name: '依田芳乃',
		kana: 'よりたよしの',
		height: '151',
		age: '16',
		weight: '40',
		birthmonth: '7',
		birthday: '3',
		bloodtype: 'O',
		handedness: 'R',
		B: '73',
		W: '53',
		H: '73',
		constellation: '蟹座',
		birthplace: '鹿児島',
		hobby: '悩み事解決・石ころ集め・失せ物探し',
		CV: '高田憂希',
	},
	{
		ID: '153',
		type: 'Pa',
		name: '相葉夕美',
		kana: 'あいばゆみ',
		height: '158',
		age: '18',
		weight: '42',
		birthmonth: '4',
		birthday: '15',
		bloodtype: 'O',
		handedness: 'R',
		B: '81',
		W: '57',
		H: '80',
		constellation: '牡羊座',
		birthplace: '神奈川',
		hobby: 'ガーデニング',
		CV: '木村珠莉',
	},
	{
		ID: '154',
		type: 'Pa',
		name: '野々村そら',
		kana: 'ののむらそら',
		height: '157',
		age: '15',
		weight: '46',
		birthmonth: '1',
		birthday: '3',
		bloodtype: 'B',
		handedness: 'R',
		B: '84',
		W: '57',
		H: '85',
		constellation: '山羊座',
		birthplace: '福岡',
		hobby: '友達と電話',
		CV: '',
	},
	{
		ID: '155',
		type: 'Pa',
		name: '浜川愛結奈',
		kana: 'はまかわあゆな',
		height: '168',
		age: '22',
		weight: '50',
		birthmonth: '5',
		birthday: '25',
		bloodtype: 'B',
		handedness: 'R',
		B: '92',
		W: '58',
		H: '85',
		constellation: '双子座',
		birthplace: '大阪',
		hobby: '乗馬',
		CV: '',
	},
	{
		ID: '156',
		type: 'Pa',
		name: '若林智香',
		kana: 'わかばやしともか',
		height: '156',
		age: '17',
		weight: '45',
		birthmonth: '8',
		birthday: '30',
		bloodtype: 'A',
		handedness: 'R',
		B: '82',
		W: '57',
		H: '83',
		constellation: '乙女座',
		birthplace: '鹿児島',
		hobby: 'チアリーディング',
		CV: '',
	},
	{
		ID: '157',
		type: 'Pa',
		name: '城ヶ崎美嘉',
		kana: 'じょうがさきみか',
		height: '162',
		age: '17',
		weight: '43',
		birthmonth: '11',
		birthday: '12',
		bloodtype: 'AB',
		handedness: 'L',
		B: '80',
		W: '56',
		H: '82',
		constellation: '蠍座',
		birthplace: '埼玉',
		hobby: 'カラオケ',
		CV: '佳村はるか',
	},
	{
		ID: '158',
		type: 'Pa',
		name: '城ヶ崎莉嘉',
		kana: 'じょうがさきりか',
		height: '149',
		age: '12',
		weight: '36',
		birthmonth: '7',
		birthday: '30',
		bloodtype: 'B',
		handedness: 'L',
		B: '72',
		W: '54',
		H: '75',
		constellation: '獅子座',
		birthplace: '埼玉',
		hobby: 'シール集め',
		CV: '山本希望',
	},
	{
		ID: '159',
		type: 'Pa',
		name: '仙崎恵磨',
		kana: 'せんざきえま',
		height: '156',
		age: '21',
		weight: '45',
		birthmonth: '6',
		birthday: '27',
		bloodtype: 'O',
		handedness: 'L',
		B: '81',
		W: '55',
		H: '81',
		constellation: '蟹座',
		birthplace: '大阪',
		hobby: '革小物集め',
		CV: '',
	},
	{
		ID: '160',
		type: 'Pa',
		name: '日野茜',
		kana: 'ひのあかね',
		height: '148',
		age: '17',
		weight: '40',
		birthmonth: '8',
		birthday: '4',
		bloodtype: 'AB',
		handedness: 'R',
		B: '80',
		W: '60',
		H: '82',
		constellation: '獅子座',
		birthplace: '栃木',
		hobby: 'ラグビー観戦',
		CV: '赤﨑千夏',
	},
	{
		ID: '161',
		type: 'Pa',
		name: '諸星きらり',
		kana: 'もろぼしきらり',
		height: '182',
		age: '17',
		weight: '60',
		birthmonth: '9',
		birthday: '1',
		bloodtype: 'O',
		handedness: 'R',
		B: '91',
		W: '64',
		H: '86',
		constellation: '乙女座',
		birthplace: '東京',
		hobby: 'かわいい物集め',
		CV: '松嵜麗',
	},
	{
		ID: '162',
		type: 'Pa',
		name: '十時愛梨',
		kana: 'とときあいり',
		height: '161',
		age: '18',
		weight: '46',
		birthmonth: '12',
		birthday: '8',
		bloodtype: 'O',
		handedness: 'R',
		B: '86',
		W: '58',
		H: '88',
		constellation: '射手座',
		birthplace: '秋田',
		hobby: 'ケーキ作り',
		CV: '原田ひとみ',
	},
	{
		ID: '163',
		type: 'Pa',
		name: 'ナターリア',
		kana: 'なたーりあ',
		height: '155',
		age: '14',
		weight: '43',
		birthmonth: '6',
		birthday: '29',
		bloodtype: 'A',
		handedness: 'R',
		B: '84',
		W: '55',
		H: '86',
		constellation: '蟹座',
		birthplace: 'リオ・デ・ジャネイロ',
		hobby: 'ベリーダンス',
		CV: '生田輝',
	},
	{
		ID: '164',
		type: 'Pa',
		name: '相場夏美',
		kana: 'そうまなつみ',
		height: '160',
		age: '25',
		weight: '46',
		birthmonth: '7',
		birthday: '23',
		bloodtype: 'A',
		handedness: 'R',
		B: '83',
		W: '60',
		H: '89',
		constellation: '獅子座',
		birthplace: '京都',
		hobby: 'ランニング',
		CV: '',
	},
	{
		ID: '165',
		type: 'Pa',
		name: '槙原志保',
		kana: 'まきはらしほ',
		height: '162',
		age: '19',
		weight: '46',
		birthmonth: '4',
		birthday: '27',
		bloodtype: 'B',
		handedness: 'R',
		B: '86',
		W: '57',
		H: '91',
		constellation: '牡牛座',
		birthplace: '三重',
		hobby: 'スイーツめぐり',
		CV: '',
	},
	{
		ID: '166',
		type: 'Pa',
		name: '向井拓海',
		kana: 'むかいたくみ',
		height: '163',
		age: '18',
		weight: '53',
		birthmonth: '8',
		birthday: '7',
		bloodtype: 'A',
		handedness: 'R',
		B: '95',
		W: '60',
		H: '87',
		constellation: '獅子座',
		birthplace: '神奈川',
		hobby: 'バイクいじり',
		CV: '原優子',
	},
	{
		ID: '167',
		type: 'Pa',
		name: '市原仁奈',
		kana: 'いちはらにな',
		height: '128',
		age: '9',
		weight: '29',
		birthmonth: '2',
		birthday: '8',
		bloodtype: 'B',
		handedness: 'L',
		B: '61',
		W: '57',
		H: '67',
		constellation: '水瓶座',
		birthplace: '静岡',
		hobby: '着ぐるみ集め',
		CV: '久野美咲',
	},
	{
		ID: '168',
		type: 'Pa',
		name: '喜多日菜子',
		kana: 'きたひなこ',
		height: '151',
		age: '5',
		weight: '38',
		birthmonth: '4',
		birthday: '6',
		bloodtype: 'AB',
		handedness: 'R',
		B: '78',
		W: '56',
		H: '78',
		constellation: '牡羊座',
		birthplace: '秋田',
		hobby: '妄想',
		CV: '',
	},
	{
		ID: '169',
		type: 'Pa',
		name: '杉坂海',
		kana: 'すぎさかかい',
		height: '162',
		age: '18',
		weight: '45',
		birthmonth: '7',
		birthday: '20',
		bloodtype: 'B',
		handedness: 'R',
		B: '88',
		W: '58',
		H: '86',
		constellation: '蟹座',
		birthplace: '山口',
		hobby: 'ウインドサーフィン',
		CV: '',
	},
	{
		ID: '170',
		type: 'Pa',
		name: '北川真尋',
		kana: 'きたがわまひろ',
		height: '158',
		age: '17',
		weight: '43',
		birthmonth: '2',
		birthday: '17',
		bloodtype: 'O',
		handedness: 'R',
		B: '75',
		W: '57',
		H: '59',
		constellation: '水瓶座',
		birthplace: '香川',
		hobby: '走ること・食べること・寝ること',
		CV: '',
	},
	{
		ID: '171',
		type: 'Pa',
		name: 'メアリー・コクラン',
		kana: 'めありー・こくらん',
		height: '152',
		age: '11',
		weight: '41',
		birthmonth: '1',
		birthday: '19',
		bloodtype: 'B',
		handedness: 'L',
		B: '71',
		W: '59',
		H: '73',
		constellation: '山羊座',
		birthplace: 'サンフランシスコ',
		hobby: '女磨き・グルメツアー',
		CV: '',
	},
	{
		ID: '172',
		type: 'Pa',
		name: '小松伊吹',
		kana: 'こまついぶき',
		height: '165',
		age: '19',
		weight: '48',
		birthmonth: '11',
		birthday: '17',
		bloodtype: 'O',
		handedness: 'R',
		B: '85',
		W: '59',
		H: '88',
		constellation: '蟹座',
		birthplace: '茨城',
		hobby: 'ストリートダンス・スケボー・恋愛映画を見る事',
		CV: '',
	},
	{
		ID: '173',
		type: 'Pa',
		name: '三好紗南',
		kana: 'みよしさな',
		height: '149',
		age: '14',
		weight: '39',
		birthmonth: '6',
		birthday: '25',
		bloodtype: 'B',
		handedness: 'R',
		B: '75',
		W: '56',
		H: '80',
		constellation: '蟹座',
		birthplace: '香川',
		hobby: 'TVゲーム・夜更かし',
		CV: '',
	},
	{
		ID: '174',
		type: 'Pa',
		name: 'キャシー・グラハム',
		kana: 'きゃしー・ぐらはむ',
		height: '168',
		age: '15',
		weight: '49',
		birthmonth: '9',
		birthday: '19',
		bloodtype: 'O',
		handedness: 'L',
		B: '83',
		W: '56',
		H: '85',
		constellation: '乙女座',
		birthplace: 'ニューヨーク',
		hobby: 'インラインスケート・ダンス',
		CV: '',
	},
	{
		ID: '175',
		type: 'Pa',
		name: '難波笑美',
		kana: 'なんばえみ',
		height: '158',
		age: '17',
		weight: '45',
		birthmonth: '5',
		birthday: '1',
		bloodtype: 'O',
		handedness: 'R',
		B: '82',
		W: '56',
		H: '80',
		constellation: '牡牛座',
		birthplace: '大阪',
		hobby: 'お笑いライブ巡り、モノマネ',
		CV: '伊達珠里紗',
	},
	{
		ID: '176',
		type: 'Pa',
		name: '浜口あやめ',
		kana: 'はまぐちあやめ',
		height: '154',
		age: '15',
		weight: '42',
		birthmonth: '1',
		birthday: '13',
		bloodtype: 'A',
		handedness: 'L',
		B: '78',
		W: '55',
		H: '80',
		constellation: '山羊座',
		birthplace: '三重',
		hobby: '時代劇鑑賞、忍者グッズ収集、撮影所巡り',
		CV: '田澤茉純',
	},
	{
		ID: '177',
		type: 'Pa',
		name: '村上巴',
		kana: 'むらかみともえ',
		height: '146',
		age: '13',
		weight: '37',
		birthmonth: '1',
		birthday: '3',
		bloodtype: 'A',
		handedness: 'R',
		B: '74',
		W: '53',
		H: '76',
		constellation: '山羊座',
		birthplace: '広島',
		hobby: '演歌、将棋',
		CV: '花井美春',
	},
	{
		ID: '178',
		type: 'Pa',
		name: '土屋亜子',
		kana: 'つちやあこ',
		height: '156',
		age: '15',
		weight: '42',
		birthmonth: '5',
		birthday: '2',
		bloodtype: 'B',
		handedness: 'R',
		B: '85',
		W: '54',
		H: '83',
		constellation: '牡牛座',
		birthplace: '静岡',
		hobby: '貯金、食べること',
		CV: '',
	},
	{
		ID: '179',
		type: 'Pa',
		name: '首藤葵',
		kana: 'しゅとうあおい',
		height: '145',
		age: '13',
		weight: '39',
		birthmonth: '8',
		birthday: '18',
		bloodtype: 'O',
		handedness: 'R',
		B: '73',
		W: '53',
		H: '75',
		constellation: '獅子座',
		birthplace: '大分',
		hobby: '魚さばき',
		CV: '',
	},
	{
		ID: '180',
		type: 'Pa',
		name: '冴島清美',
		kana: 'さえじまきよみ',
		height: '153',
		age: '15',
		weight: '43',
		birthmonth: '9',
		birthday: '26',
		bloodtype: 'A',
		handedness: 'R',
		B: '76',
		W: '58',
		H: '78',
		constellation: '天秤座',
		birthplace: '沖縄',
		hobby: '掃除、整理整頓、腕章作り',
		CV: '',
	},
	{
		ID: '181',
		type: 'Pa',
		name: '佐藤心',
		kana: 'さとうしん',
		height: '166',
		age: '26',
		weight: 'ダイエットちゅう',
		birthmonth: '7',
		birthday: '22',
		bloodtype: 'AB',
		handedness: 'R',
		B: 'ぼんっ',
		W: 'きゅっ',
		H: 'ぼんっ♪',
		constellation: '蟹座',
		birthplace: '長野',
		hobby: 'ドレスアップ・衣装作り',
		CV: '花守ゆみり',
	},
	{
		ID: '182',
		type: 'Pa',
		name: '南条光',
		kana: 'なんじょうひかる',
		height: '140',
		age: '14',
		weight: '41',
		birthmonth: '9',
		birthday: '13',
		bloodtype: 'B',
		handedness: 'R',
		B: '79',
		W: '58',
		H: '80',
		constellation: '乙女座',
		birthplace: '徳島',
		hobby: '特撮番組鑑賞、特撮ごっこ',
		CV: '',
	},
	{
		ID: '183',
		type: 'Pa',
		name: 'イヴ・サンタクロース',
		kana: 'いう゛・さんたくろーす',
		height: '165',
		age: '19',
		weight: '44',
		birthmonth: '12',
		birthday: '24',
		bloodtype: 'B',
		handedness: 'R',
		B: '81',
		W: '56',
		H: '80',
		constellation: '山羊座',
		birthplace: 'グリーンランド',
		hobby: '煙突探し',
		CV: '',
	},
	{
		ID: '184',
		type: 'Cu',
		name: '辻野あかり',
		kana: 'つじのあかり',
		height: '160',
		age: '15',
		weight: '44',
		birthmonth: '11',
		birthday: '5',
		bloodtype: 'A',
		handedness: 'R',
		B: '80',
		W: '60',
		H: '86',
		constellation: '蠍座',
		birthplace: '山形',
		hobby: 'ラーメン、編み物',
		CV: null,
	},
	{
		ID: '185',
		type: 'Cu',
		name: '黒埼ちとせ',
		kana: 'くろさきちとせ',
		height: '164',
		age: '19',
		weight: '44',
		birthmonth: '11',
		birthday: '10',
		bloodtype: 'O',
		handedness: 'R',
		B: '86',
		W: '58',
		H: '84',
		constellation: '蠍座',
		birthplace: '東京',
		hobby: '美味しいものを食べること、月光浴',
		CV: '佐倉薫',
	},
	{
		ID: '186',
		type: 'Cu',
		name: '白雪千夜',
		kana: 'しらゆきちよ',
		height: '157',
		age: '17',
		weight: '40',
		birthmonth: '2',
		birthday: '4',
		bloodtype: 'O',
		handedness: 'R',
		B: '72',
		W: '52',
		H: '74',
		constellation: '水瓶座',
		birthplace: '北海道',
		hobby: '料理・睡眠',
		CV: '関口理咲',
	},
	{
		ID: '187',
		type: 'Co',
		name: '砂塚あきら',
		kana: 'すなづかあきら',
		height: '154',
		age: '15',
		weight: '42',
		birthmonth: '10',
		birthday: '7',
		bloodtype: 'B',
		handedness: 'R',
		B: '78',
		W: '56',
		H: '78',
		constellation: '天秤座',
		birthplace: '新潟',
		hobby: 'ファッション、動画配信、FPS',
		CV: null,
	},
	{
		ID: '188',
		type: 'Co',
		name: '久川颯',
		kana: 'ひさかわはやて',
		height: '151',
		age: '14',
		weight: '42',
		birthmonth: '6',
		birthday: '16',
		bloodtype: 'B',
		handedness: 'R',
		B: '82',
		W: '56',
		H: '82',
		constellation: '双子座',
		birthplace: '徳島',
		hobby: 'ファッション・流行の店巡り',
		CV: '長江里加',
	},
	{
		ID: '189',
		type: 'Pa',
		name: '夢見りあむ',
		kana: 'ゆめみりあむ',
		height: '149',
		age: '19',
		weight: 'リンゴたくさん',
		birthmonth: '9',
		birthday: '12',
		bloodtype: 'AB',
		handedness: 'R',
		B: 'でっかい',
		W: 'ふつう',
		H: 'たぶんふつう',
		constellation: '乙女座',
		birthplace: 'やさしい世界',
		hobby: '夜中の意味深ポエム、現場参戦',
		CV: '星希成奏',
	},
	{
		ID: '190',
		type: 'Pa',
		name: '久川凪',
		kana: 'ひさかわなぎ',
		height: '150',
		age: '14',
		weight: '40',
		birthmonth: '6',
		birthday: '16',
		bloodtype: 'B',
		handedness: 'R',
		B: '76',
		W: '56',
		H: '80',
		constellation: '双子座',
		birthplace: '徳島',
		hobby: '写真・ポエム・読書(新書)',
		CV: '立花日菜',
	},
]
export default data
